import { render, staticRenderFns } from "./customMinip-edit.vue?vue&type=template&id=6a1e38ed&scoped=true"
import script from "./customMinip-edit.vue?vue&type=script&lang=js"
export * from "./customMinip-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e38ed",
  null
  
)

export default component.exports